export default {
      id: "circle__clock-2-usage",
      viewBox: "0 0 19 19",
      url: __webpack_public_path__ + "img/icons.svg#circle__clock-2",
      toString: function () {
        return this.url;
      }
    }